export default "__VITE_ASSET__wLFfsO_b__"